import React from 'react';
import { Autocomplete, Chip, TextField } from '@mui/material';
import PlaceOutlined from '@mui/icons-material/PlaceOutlined';

interface StateFilterSelectProps {
  options: string[];
  value: string[];
  onChange: (states: string[]) => void;
  disabled?: boolean;
}

export default function StateFilterSelect({
  options,
  value,
  onChange,
  disabled,
}: StateFilterSelectProps) {
  return (
    <Autocomplete
      multiple
      size="small"
      limitTags={2}
      value={value}
      onChange={(_e, next) => onChange(next)}
      options={options}
      disabled={disabled}
      disableCloseOnSelect
      autoHighlight
      sx={{ width: 220 }}
      renderTags={(selected, getTagProps) =>
        selected.map((state, index) => (
          <Chip
            {...getTagProps({ index })}
            key={state}
            size="small"
            label={state}
            sx={{ height: 20, '& .MuiChip-label': { px: 0.75, fontSize: 11 } }}
          />
        ))
      }
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={value.length ? '' : 'All states'}
          label="State"
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <>
                <PlaceOutlined sx={{ fontSize: 16, color: 'text.disabled', ml: 0.5, mr: -0.25 }} />
                {params.InputProps.startAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
}
